



















































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import EmptyState from "@/components/EmptyState/EmptyState.vue";
import StatsCard from "@/components/Stats/StatsCard.vue";
import ExportButton from "@/components/Export/ExportButton.vue";
import ThemeSwitcher from "@/components/ThemeSwitcher/ThemeSwitcher.vue";

@Component({
  name: "ComponentsDemo",
  components: {
    EmptyState,
    StatsCard,
    ExportButton,
    ThemeSwitcher,
  },
})
export default class ComponentsDemo extends Vue {
  snackbar = false;
  snackbarText = "";
  snackbarColor = "success";

  sampleData = [
    {
      id: 1,
      nombre: "Juan Pérez",
      email: "juan@example.com",
      departamento: "IT",
      salario: "$50,000",
    },
    {
      id: 2,
      nombre: "María García",
      email: "maria@example.com",
      departamento: "Ventas",
      salario: "$45,000",
    },
    {
      id: 3,
      nombre: "Carlos López",
      email: "carlos@example.com",
      departamento: "Marketing",
      salario: "$48,000",
    },
    {
      id: 4,
      nombre: "Ana Martínez",
      email: "ana@example.com",
      departamento: "RRHH",
      salario: "$52,000",
    },
    {
      id: 5,
      nombre: "Pedro Sánchez",
      email: "pedro@example.com",
      departamento: "IT",
      salario: "$55,000",
    },
  ];

  get currentTheme(): string {
    return this.$vuetify.theme.dark ? "Oscuro" : "Claro";
  }

  showAlert(message: string): void {
    this.snackbarText = message;
    this.snackbarColor = "info";
    this.snackbar = true;
  }

  onExported(data: any): void {
    this.snackbarText = `Datos exportados a ${data.format.toUpperCase()} exitosamente`;
    this.snackbarColor = "success";
    this.snackbar = true;
  }

  onExportError(error: any): void {
    this.snackbarText = `Error al exportar: ${error}`;
    this.snackbarColor = "error";
    this.snackbar = true;
  }

  onThemeChanged(isDark: boolean): void {
    this.snackbarText = `Tema cambiado a ${isDark ? "oscuro" : "claro"}`;
    this.snackbarColor = "info";
    this.snackbar = true;
  }
}
